<div class="col full-height layout-row gap-5"
     [ngClass]="{'selected': isSelected}"
     (contextmenu)="onRightClick($event)">

  <div class="flex layout-row layout-wrap info-container">

    <!--Link Row-->
    <div class="flex-100 layout-row layout-align-start-center service-title gap-5">
      <app-bringoz-checkbox [isChecked]="isSelected"
                            (clickEvent)="onToggleEvent($event)">
      </app-bringoz-checkbox>

      <app-bringoz-status-tag [status]="service.status"
                              [extraTooltipText]="service?.cancellationReason?.reason"
                              [isSmall]="true"
                              class="margin-right-5">

      </app-bringoz-status-tag>

      <app-service-link [serviceType]="service.serviceType"
                        [id]="service.id"
                        [externalId]="service.externalId"
                        isAllowCopyButton="true">
      </app-service-link>

      <app-service-type-indication [serviceType]="service.serviceType"
                                   [isShort]="true">

      </app-service-type-indication>

<!--      <app-oms-order-link *ngIf="service.omsOrderReference?.id"-->
<!--                          [internalId]="service.omsOrderReference?.id"-->
<!--                          [externalId]="service.omsOrderReference?.externalId">-->
<!--      </app-oms-order-link>-->

    </div>

    <!--Address Row-->
    <div *ngIf="settings?.columns?.location && !itemElementSize"
         class="flex-100 layout-row layout-align-start-center info-row">
      <!--Stops Address-->
      <div class="flex layout-row layout-align-start-center gap-5 text-ellipsis"
           *ngFor="let task of service.taskList">
        <bringoz-icon iconName="location-pin-outline"
                      classSize="md"
                      [fill]="task.taskSpec?.purpose === 'Pickup' ? '#FF9936' : (task.taskSpec?.purpose === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Address' | translate"
                      openDelay="300">
        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ task.taskSpec.address | bringozAddress }}</span>
      </div>

    </div>

    <ng-container *ngIf="settings?.columns?.location && !!itemElementSize">
      <!--Stops Address-->
      <div class="layout-row layout-align-start-center text-ellipsis  gap-5"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           *ngFor="let task of service.taskList">
        <bringoz-icon iconName="location-pin-outline"
                      classSize="md"
                      [fill]="task.taskSpec?.purpose === 'Pickup' ? '#FF9936' : (task.taskSpec?.purpose === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Address' | translate"
                      openDelay="300">
        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ task.taskSpec.address | bringozAddress }}</span>
      </div>
    </ng-container>

    <!--Time Window Row-->
    <div *ngIf="settings?.columns?.timeWindow && !itemElementSize"
         class="flex-100 layout-row layout-align-start-center info-row">

      <!--Stops Time Window-->
      <div class="flex layout-row layout-align-start-center gap-5 text-ellipsis"
           *ngFor="let task of service.taskList">
        <bringoz-icon iconName="time-window-outline"
                      classSize="md"
                      [fill]="task.taskSpec?.purpose === 'Pickup' ? '#FF9936' : (task.taskSpec?.purpose === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Time Window' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ task.taskSpec | timeWindow }}</span>

      </div>

    </div>

    <ng-container *ngIf="settings?.columns?.timeWindow && !!itemElementSize">
      <!--Stops Time Window-->
      <div class="layout-row layout-align-start-center text-ellipsis gap-5 "
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           *ngFor="let task of service.taskList">
        <bringoz-icon iconName="time-window-outline"
                      classSize="md"
                      [fill]="task.taskSpec?.purpose === 'Pickup' ? '#FF9936' : (task.taskSpec?.purpose === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Time Window' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ task.taskSpec | timeWindow }}</span>

      </div>
    </ng-container>

    <!--Contacts Row-->
    <div *ngIf="settings?.columns?.contact && !itemElementSize"
         class="flex-100 layout-row layout-align-start-center info-row">
      <!--Stops Contacts-->
      <div class="layout-row layout-align-start-center gap-5 text-ellipsis flex"
           *ngFor="let task of service.taskList">
        <bringoz-icon iconName="contact-circle"
                      classSize="md"
                      [fill]="task.taskSpec?.purpose === 'Pickup' ? '#FF9936' : (task.taskSpec?.purpose === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Contact' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ task.taskSpec?.contact?.name || '---' }}</span>

      </div>
    </div>

    <!--Pro Number Row-->
    <div *ngIf="settings?.columns?.proNumber && !itemElementSize"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="hash"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Pro Number' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1">{{service.proNumber || '---'}}</span>
    </div>

    <ng-container *ngIf="settings?.columns?.proNumber && !!itemElementSize">
      <bringoz-icon iconName="hash"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Pro Number' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1">{{service.proNumber || '---'}}</span>
    </ng-container>

    <ng-container *ngIf="settings?.columns?.contact && !!itemElementSize">
      <!--Stops Contacts-->
      <div class="layout-row layout-align-start-center text-ellipsis gap-5 "
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           *ngFor="let task of service.taskList">
        <bringoz-icon iconName="contact-circle"
                      classSize="md"
                      [fill]="task.taskSpec?.purpose === 'Pickup' ? '#FF9936' : (task.taskSpec?.purpose === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Contact' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ task.taskSpec?.contact?.name || '---' }}</span>

      </div>
    </ng-container>

    <!--Route Row-->
    <div *ngIf="settings?.columns?.route && !itemElementSize"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="route"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Route' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1"
            [ngClass]="{'clickable-route-id': !!service.routeId}"
            (click)="service.routeId && onRouteIdClick($event, service.routeId)">{{service.routeId || '---'}}</span>
    </div>

    <ng-container *ngIf="settings?.columns?.route && !!itemElementSize">
      <bringoz-icon iconName="route"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Route' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1"
            [ngClass]="{'clickable-route-id': !!service.routeId}"
            (click)="service.routeId && onRouteIdClick($event, service.routeId)">{{service.routeId || '---'}}</span>
    </ng-container>

    <!--Resource Row-->
    <div *ngIf="settings?.columns?.resource && !itemElementSize"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="tiles-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Resource' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1">{{service.routeReference?.resourceName || '---'}}</span>
    </div>

    <ng-container *ngIf="settings?.columns?.resource && !!itemElementSize">
      <bringoz-icon iconName="tiles-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Resource' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1">{{service.routeReference?.resourceName || '---'}}</span>
    </ng-container>

    <!--Service Time Row-->
    <div *ngIf="settings?.columns?.serviceTime && !itemElementSize"
         class="flex-100 layout-row layout-align-start-center info-row">

      <!--Stops Time Window-->
      <div class="flex layout-row layout-align-start-center gap-5 text-ellipsis"
           *ngFor="let task of service.taskList">
        <bringoz-icon iconName="timer-outline"
                      classSize="md"
                      [fill]="task.taskSpec?.purpose === 'Pickup' ? '#FF9936' : (task.taskSpec?.purpose === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Service Time' | translate"
                      openDelay="300">

        </bringoz-icon>
        <div *ngIf="!task.taskSpec?.detailedServiceTime" class="layout-row layout-align-start-center text-ellipsis">
          <span class="br-body-1 text-ellipsis">{{ task.taskSpec?.serviceTime | bringozTimeConvert: true }}</span>
        </div>
        <app-task-detailed-service-time *ngIf="!!task.taskSpec?.detailedServiceTime"
                                        class="margin-left-5 text-ellipsis"
                                        [fontSize]="'br-body-1'"
                                        [isAllowEdit]="false"
                                        [detailedServiceTime]="task.taskSpec?.detailedServiceTime">
        </app-task-detailed-service-time>
      </div>

    </div>

    <ng-container *ngIf="settings?.columns?.serviceTime && !!itemElementSize">
      <!--Stops Time Window-->
      <div class="layout-row layout-align-start-center text-ellipsis gap-5 "
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           *ngFor="let task of service.taskList">
        <bringoz-icon iconName="timer-outline"
                      classSize="md"
                      [fill]="task.taskSpec?.purpose === 'Pickup' ? '#FF9936' : (task.taskSpec?.purpose === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Service Time' | translate"
                      openDelay="300">

        </bringoz-icon>
        <div *ngIf="!task.taskSpec?.detailedServiceTime" class="layout-row layout-align-start-center text-ellipsis">
          <span class="br-body-1 text-ellipsis">{{ task.taskSpec?.serviceTime | bringozTimeConvert: true }}</span>
        </div>
        <app-task-detailed-service-time *ngIf="!!task.taskSpec?.detailedServiceTime"
                                        class="margin-left-5 text-ellipsis"
                                        [fontSize]="'br-body-1'"
                                        [isAllowEdit]="false"
                                        [detailedServiceTime]="task.taskSpec?.detailedServiceTime">
        </app-task-detailed-service-time>
      </div>
    </ng-container>

    <!--Account-->
    <div *ngIf="settings?.columns?.account"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 text-ellipsis ">
      <bringoz-icon iconName="account"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Account' | translate"
                    openDelay="300">

      </bringoz-icon>

      <app-demand-account-link [account]="service.account"
                               [isAllowCopyButton]="true">

      </app-demand-account-link>
    </div>

    <!--Tags Row-->
    <div *ngIf="settings?.columns?.tags"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="label-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Labels' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-tags *ngIf="!!serviceTags.length" [tags]="serviceTags" maxTags="2"
                        class="margin-top-5">

      </app-bringoz-tags>
    </div>

    <!--Price Row-->
    <div *ngIf="settings?.columns?.price"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="dollar-circle"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Price' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ service.billingReference?.courierPrice | bringozPrice: '---' }}</span>
    </div>

    <!--Skills Row-->
    <div *ngIf="settings?.columns?.skills"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="skill-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Skills' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-skill-tags [skillsIds]="service.requiredSkills"></app-skill-tags>
    </div>

    <!--Packages-->
    <div *ngIf="settings?.columns?.packages"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="package-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Packages' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-packages-items-display-list *ngIf="!!service && service?.packageList?.length"
                                               [items]="service.packageList[0].items">

      </app-bringoz-packages-items-display-list>
    </div>

    <!--Relations Row-->
    <div *ngIf="settings?.columns?.relations"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <app-task-relations-indicator [relations]="relations"
                                    (onClick)="onRelationsClick($event)">
      </app-task-relations-indicator>
    </div>

    <!--Load - Weight-->
    <div *ngIf="settings?.load?.weight"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="weight"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Weight' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ service.packageList | packageWeight:true }}</span>
    </div>

    <!--Load - Volume-->
    <div *ngIf="settings?.load?.volume"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="volume"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Volume' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ service.packageList | packageVolume:true }}</span>
    </div>

    <!--Load - Packages-->
    <div *ngIf="settings?.load?.packages"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="package-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Packages' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ service.packageList | packageTotalItems }}</span>
    </div>

    <!--Load - Value-->
    <div *ngIf="settings?.load?.value"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="dollar-circle"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Value' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ service.packageList | packageTotalValue }}</span>
    </div>

    <!--Load - Pallets-->
    <div *ngIf="settings?.load?.pallets"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="pallets"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Pallets' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ service.packageList | packagePallets }}</span>
    </div>

    <!--Load - Spots-->
    <div *ngIf="settings?.load?.spots"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="spot"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Spots' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ service.packageList | packageSpots }}</span>
    </div>

  </div>


</div>
